import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@iq/react-components';
import { Connect, Disconnect } from '@hitachivantara/uikit-react-icons';
import { useSelector, useDispatch } from 'react-redux';

import {
  getSourceConnectivity,
  getSourcesLoaded,
  requestConnectivity,
  getAggregatedStationStatus,
} from '../../../bundles/sources';
import { DEVICE_STATUS_COLOR } from '../../../constants';
import ExtendedConnectivityStatus from './ExtendedConnectivityStatus';

const getStatusColor = (status) => DEVICE_STATUS_COLOR[status];

const ConnectivityStatus = ({ siteId }) => {
  const dispatch = useDispatch();
  const sourcesLoaded = useSelector(getSourcesLoaded);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const connectedSources = useSelector(getSourceConnectivity);
  const aggregatedStationStatus = useSelector(getAggregatedStationStatus);
  const shouldShowConnectivity = config.onPremise || connectedSources.length > 0;

  useEffect(() => {
    if (sourcesLoaded && siteId) {
      dispatch(requestConnectivity(siteId));
    }
  }, [sourcesLoaded, siteId, dispatch]);

  useEffect(() => {
    if (!isOpen) return () => {};

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleToggleOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setIsOpen((previous) => !previous);
  };

  return siteId && shouldShowConnectivity ? (
    <div
      className="connectivity"
      ref={containerRef}
    >
      <Button
        design="text"
        onClick={handleToggleOpen}
        className=""
      >
        {aggregatedStationStatus === 0 ? (
          <Disconnect
            iconSize="S"
            color={[getStatusColor(aggregatedStationStatus)]}
          />
        ) : (
          <Connect
            iconSize="S"
            color={[getStatusColor(aggregatedStationStatus)]}
          />
        )}
      </Button>

      {isOpen && (
        <ExtendedConnectivityStatus
          sources={connectedSources}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  ) : null;
};

export default ConnectivityStatus;
